module.exports = __webpack_public_path__ + "img/ai-pic5.db442f79.png";